var $ = require('jQuery');
var Uploader = require('uploader');
var FileTypes = require('../../lib/filetypes');

module.exports = function() {
    new FileTypes();

    // Setup the Uploader, if included on the page.
    if ($("#uploader").length > 0) {
        new Uploader(uploaderOptions.clarify());
    }
};
